import React from 'react';
import VocabularyCardItem from '../components/VocabularyCardItem';

const VocabularyCardItems = ({ category, items }) => (
  items.map((item, index) => (
    <VocabularyCardItem
      key={`vocabularies_list_item_${item.id}`}
      category={category}
      vocabulary={item}
      upward={index > 4}
    />
  ))
);

export default VocabularyCardItems;
